export const isConversionActive = conversion => {
  return conversion?.isFutureChangeActive && conversion?.newCode;
};

export const setAgentConversionsState = (agentConversion, agentConversions, setAgentConversions) => {
  const newState = {
    isFutureChangeActive: !agentConversion.isFutureChangeActive,
    futureChangeStartDate: !agentConversion.isFutureChangeActive ? getFormattedDate(new Date(Date.now())) : null,
  };

  setAgentConversions(
    agentConversions?.map(channel =>
      channel.channelNameInUserMetadata === agentConversion.channelNameInUserMetadata
        ? {
            ...channel,
            conversions: channel.conversions?.map(conversion =>
              conversion.oldCode === agentConversion.oldCode ? { ...conversion, ...newState } : conversion
            ),
          }
        : channel
    )
  );
};

const getFormattedDate = date => {
  const year = date.getFullYear();
  const month = (1 + date.getMonth()).toString();
  const day = date.getDate().toString();

  return year + '/' + month + '/' + day;
};
